export default "__VITE_ASSET__BFrOclJC__"